import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Button } from '@creditornot/cb-button';
import { Spinner } from '@creditornot/cb-progress';
import { authenticator } from 'common/auth/authenticator';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

import { ContentContainer } from './ContentContainer';

const Root = styled(ContentContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
`;

const LogoutButton = styled(Button)`
  margin-top: 16px;
`;

export const AuthLoadingSpinner: React.FC = () => {
  const [showLogoutButton, setShowLogoutButton] = useState(false);
  const format = useFormatMessage();

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLogoutButton(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const handleLogout = () => {
    void authenticator.performLogout?.();
  };

  return (
    <Root>
      <LoadingContainer>
        <Spinner size="extraLarge" />
        {showLogoutButton && (
          <LogoutButton
            variant="secondary"
            size="large"
            onClick={handleLogout}
            data-test-id="auth-loading-logout-button"
          >
            {format('components.navigation_menu.sign_out')}
          </LogoutButton>
        )}
      </LoadingContainer>
    </Root>
  );
};
